import React, { useState, useEffect, forwardRef } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import Empty from "@/Assets/entity.png";
import TableComp from "@/Components/Tables/TableComp";

import { useUser } from "@/Context/UserContext";
import { iconMap } from "@/redux/iconMap";

const TableGenerator = forwardRef(
  (
    {
      compKey,
      visibleFields,
      expandedFields,
      handleSave,
      label,
      handlers,
      actions,
      loading,
      showActions = true,
    },
    ref
  ) => {
    const [showForm, setShowForm] = useState(false);
    const { formData, isDataFetched } = useUser();
  const[schemaKey,setSchemaKey] = useState(null)
    // get the data from formData state for the specific tab data
    const [tableData, setTableData] = useState(formData[compKey] || []);
    useEffect(() => {
      const data = formData?.[compKey] || [];

      const transformedData =
        Array.isArray(data) &&
        data.map((item) => {
          const newItem = { ...item, __schemaKey: schemaKey,  };

          return newItem;
        });

      setTableData(transformedData);
    }, [formData, compKey,schemaKey]);

    const [btnActions] = useState(
      showActions
        ? actions || [
            {
              icon: "FiEdit2",
              title: "Edit",
              handler: "handleEdit",
            },
            {
              icon: "LuTrash2",
              title: "Delete",
              handler: "handleRemove",
            },
          ]
        : null
    );

    const transformedActions = btnActions?.map((action) => {
      const newAction = { ...action };

      // Generic show logic for "View" icon
      if (action.handler === "handleView") {
        newAction.show = (row) =>
          Object.values(row).some(
            (val) =>
              val &&
              typeof val === "object" &&
              "filePath" in val &&
              "fileName" in val
          );
      }
      const IconComponent = iconMap[action.icon];

      return {
        ...action,
        icon: IconComponent ? (
          <IconComponent style={{ fontSize: 20, color: "var(--brand-600)" }} />
        ) : null,
        onClick: handlers[action?.handler],
        type: "text",
      };
    });

    // Empty State UI
    const EmptyState = ({ label }) => (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          py: "13%",
          gap: 2,
        }}
      >
        <img src={Empty} alt="Entity" width={102} height={80} />
        <Typography variant="bodyBase" color="var(--gray-800)">
          No {label} created yet. <br /> Please create a new one.
        </Typography>
      </Box>
    );

    if (!isDataFetched || loading) {
      return (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "200px",
            width: "100%",
          }}
        >
          <CircularProgress size={40} sx={{ color: "var(--brand-600)" }} />
        </Box>
      );
    }

    return (
      <Box sx={{ backgroundColor: "var(--gray-0)", width: "100%" }}>
        {tableData?.length === 0 && !showForm && <EmptyState label={label} />}

        {tableData?.length > 0 && (
          <Box>
            <TableComp
              tableData={tableData}
              onEdit={handlers.handleEdit}
              onDelete={handlers.handleDelete}
              visibleFields={visibleFields}
              expandedFields={expandedFields}
              actions={btnActions ? transformedActions : null}
              onRowClick={handlers.handleRowClick}
              setSchemaKey={setSchemaKey}
            />
          </Box>
        )}
      </Box>
    );
  }
);

export default TableGenerator;
